import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Apollo, gql } from 'apollo-angular';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CollectorResolver {
  constructor(
    private apollo: Apollo,
    public router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const GET_COLLECTOR = gql`
      query ($id: ID!) {
        collector(id: $id) {
          id
          tenantId
          name
          alias
          taxEntityId
          brandId
          serviceIds
          channelConfigIds
          paymentGatewayIds
          eventHookConfigIds
          feedbackOptionIds
          regionalConfigId
        }
      }
    `;

    return this.apollo.query({
      query: GET_COLLECTOR,
      variables: {
        id: route.paramMap.get('id'),
      },
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class CollectorListResolver {
  constructor(private apollo: Apollo) {}

  resolve(route: ActivatedRouteSnapshot) {
    const GET_COLLECTORS = gql`
      query ($tenantId: ID!) {
        searchCollectors(tenantId: $tenantId) {
          id
          name
          alias
          tenantId
          taxEntityId
          brandId
          serviceIds
          channelConfigIds
          eventHookConfigIds
          feedbackOptionIds
          paymentGatewayIds
          regionalConfigId
          currency
        }
      }
    `;

    return this.apollo
      .query({
        query: GET_COLLECTORS,
        variables: {
          tenantId: route.queryParamMap.get('tenant'),
        },
      })
      .pipe(map((res: any) => res.data?.searchCollectors ?? []));
  }
}

@Injectable({
  providedIn: 'root',
})
export class PortfolioResolver {
  constructor(private apollo: Apollo) {}

  resolve(route: ActivatedRouteSnapshot) {
    const tenantId = route.queryParamMap.get('tenant');

    const GET_PORTFOLIOS = gql`
      query ($tenantId: ID!) {
        portfolios(tenantId: $tenantId) {
          id
          tenantId
          alias
          name
          isDefault
        }
      }
    `;

    return this.apollo
      .query({
        query: GET_PORTFOLIOS,
        variables: { tenantId },
      })
      .pipe(map((res: any) => res.data.portfolios));
  }
}
